import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { rootRoute } from './root';
import { getSession } from '@/lib/auth-client';
import { consoleAccess } from '@/lib/console-admin';
import { PermissionProvider } from '@/lib/permissions';
import { RouteError } from '@/admin/ConsoleRouteError';
import { reportRenderError } from '@/lib/rum';

// Cross-pool lead search over finished calls. Lazy-loaded like /responsiveness so the
// cockpit's chunk never pays for it, and gated on its own permission rather than the
// console's: this page answers with the lead's own record, which the console otherwise
// holds back.

function CallHistoryGate() {
  const { userEmail, role } = callHistoryRoute.useRouteContext();
  return (
    <PermissionProvider role={role}>
      <LazyCallHistoryPage userEmail={userEmail} />
    </PermissionProvider>
  );
}

const LazyCallHistoryPage = lazyRouteComponent(() => import('@/admin/CallHistoryPage'));

export const callHistoryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/call-history',
  beforeLoad: async () => {
    const { data } = await getSession();
    if (!data) throw redirect({ to: '/login' });
    const { allowed, role } = await consoleAccess('call-history:read');
    if (!allowed) throw redirect({ to: '/' });
    return { userEmail: data.user.email, role };
  },
  component: CallHistoryGate,
  errorComponent: RouteError,
  onCatch: (error) => reportRenderError(error, 'route:call-history'),
});
